import { axiosService } from 'ui-model';

// TODO pedro avoid importing from `@lumahealthhq/ui-model`
// eslint-disable-next-line no-restricted-imports
import { createQueryKey, useQuery, UseQueryOptions, IQueryParams } from '@lumahealthhq/ui-model';

const basePath = 'faxDocuments';

export default function useFaxByPatientId<T>(params: IQueryParams<T>, options?: UseQueryOptions<T[]>) {
  const basePathFaxesByPatient = `${basePath}`;
  const variant = 'v2/{basePath}';

  async function queryFn() {
    const url = variant.replace('{basePath}', basePathFaxesByPatient);
    const { data } = await axiosService.get(url, { params });
    return (data?.response || data || []) as T[];
  }

  const queryKey = createQueryKey(basePathFaxesByPatient, variant, params);
  const queryResult = useQuery(queryKey, queryFn, options);
  return queryResult;
}
